import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { PATTER_DATE_BRAZILIAN, PATTER_DATE_TIME_BRAZILIAN, PATTER_DATE_TIME_UUID } from "./constants";

@Injectable({
    providedIn: 'root'
})
export class DateUtils {

    constructor(private datePipe: DatePipe) {
    }

    formatDate(date: any, pattern: string) {
        return this.datePipe.transform(date, pattern);
    }

    formatDateBrazilian(date: any) {
        return this.formatDate(date, PATTER_DATE_BRAZILIAN);
    }

    formatDateTimeBrazilian(date: any) {
        return this.formatDate(date, PATTER_DATE_TIME_BRAZILIAN);
    }

    formatRelativeTime(date: any): string {
        if (!date) {
            return '-';
        }
        const value = new Date(date);
        if (Number.isNaN(value.getTime())) {
            return this.formatDateTimeBrazilian(date) || '-';
        }

        const diffMs = Date.now() - value.getTime();
        const diffMinutes = Math.max(0, Math.floor(diffMs / 60000));
        if (diffMinutes < 1) {
            return 'agora';
        }
        if (diffMinutes < 60) {
            return `${diffMinutes} min atrás`;
        }
        const diffHours = Math.floor(diffMinutes / 60);
        if (diffHours < 24) {
            return `${diffHours} h atrás`;
        }
        const diffDays = Math.floor(diffHours / 24);
        if (diffDays < 7) {
            return `${diffDays} d atrás`;
        }
        return this.formatDateTimeBrazilian(date) || '-';
    }

    formatDateTimeUUID() {
        return this.formatDate(new Date(), PATTER_DATE_TIME_UUID);
    }

}